
import './App.scss';
import { Routes, Route } from "react-router-dom"
import Home from './components/Home';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar2 from './components/Navbar2';
import { Team } from './components/Team';
import { Products } from './components/Products';
import { Projects } from './components/Projects';
import { Services } from './components/Services';
import PrivacyPolicyStatement from './components/PrivacyPolicyStatement';
import Updates from './components/Updates';
import UpdatePage from './components/UpdatePage';
import Careers from './components/Careers';

function App() {
  return (
    <div className="App w-full flex flex-col items-center justify-center bg-[#212121] "> 
      <Navbar2 />
      <section className='flex flex-col items-center justify-center w-full mt-[58px]'>
        <Routes>
          <Route path="/" element={ <Home/> } />
          <Route path="about" element={ <Team/> } />
          <Route path="services" element={ <Services/> } />
          {/* <Route path="team" element={ <Team/> } /> */}
          <Route path="products" element={ <Products/> } />
          <Route path="projects" element={ <Projects/> } />
          <Route path="careers" element={ <Careers/> } />
          <Route path="contact" element={ <Contact/> } />
          {/* <Route path="updates" element={ <Updates/> }/> */}
          <Route path="updates/:id" element={<UpdatePage />} />
          <Route path="privacy-policy" element={ <PrivacyPolicyStatement/> } />
        </Routes>
      </section>
      <Footer />
    </div>
  );
}

export default App;
